import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcSigninService} from 'exc-signin';
import {ExcListConfig, ExcTableConfig} from 'exc-controls';
import {ExcFilter, ExcFilterCondition, ExcSort, FilterSortService} from '../../filter-sort-service.service';
import {ModalNewLocationComponent} from '../../modals/modal-new-location/modal-new-location.component';
import {ProviderModalAuditorEditComponent} from '../modals/provider-modal-auditor-edit/provider-modal-auditor-edit.component';
import {ProviderModalExportAuditComponent} from '../modals/provider-modal-export-audit/provider-modal-export-audit.component';
import {ProviderModalExportDealerComponent} from '../modals/provider-modal-export-dealer/provider-modal-export-dealer.component';
import {ExcFileItem} from '../../attachments/models/ExcFileItem';
import {DataImportUploadConfirmModalComponent} from '../../data-import-upload-confirm-modal/data-import-upload-confirm-modal.component';
import {ProviderModalImportByClientComponent} from '../modals/provider-modal-import-by-client/provider-modal-import-by-client.component';
import {DataImportComponent} from '../../data-import/data-import.component';

@Component({
  selector: 'app-provider-config',
  templateUrl: './provider-config.component.html',
  styles: []
})
export class ProviderConfigComponent extends ExcTranslation implements OnInit {
  auditorListData: any;
  auditorSearchValue = '';
  @ViewChild('filterMenu') filterMenu;
  @ViewChild('ldi') ldi: DataImportComponent;
  auditorListConfig: ExcTableConfig = new ExcTableConfig();
  importClientListConfig: ExcListConfig = new ExcListConfig();
  state: number;
  menuItem = [{id: 1, cat: 'ImportTitle', icon: 'upload', token: 'PRV'} ,
              {id: 2, cat: 'ExportTitle', icon: 'tools', token: 'PRV'},
              {id: 3, cat: 'AuditorsTitle', icon: 'file-alt', token: 'PRV'},
              {id: 4, cat: 'ClientsTitle', icon: 'landmark', token: 'PRV'}];
  isLoading = false;
  lstFilters: ExcFilter[] = [];
  lstSort: ExcSort[] = [];
  clientListConfig: ExcTableConfig = new ExcTableConfig();
  clientListData: any;
  clientSearchValue = '';
  clients: any[] = [];
  selected = {AuditMonth: (new Date()).getMonth() + 1 , AuditYear: (new Date()).getFullYear(), AuditStatus: 0 , mandant: 0};
  selectedClient = null;
  private json: any = null;
  public ImportID: string = null;
  public Recipients: string = null;
  @ViewChild('popUp') popup;
  selectedImportClient = {Mdt_Id: null};
  importClientList: any[] = [];
  addAuditorFirstCall = true;
  addAuditorMore = false;
  constructor(private excRest: ExcRestService, private ref: ChangeDetectorRef , private excSec: ExcSigninService, private excFss: FilterSortService) {
    super();
    const _self = this;
    _self.importClientListConfig.selectionMode = 'single';
    _self.importClientListConfig.selectFirstAfterInit = true;
    _self.importClientListConfig.OnFocus = (focusItem, event?) => {
      _self.selectedImportClient = focusItem;
        if ( _self.ldi !== undefined) {
          _self.ldi.refresh(_self.selectedImportClient.Mdt_Id);
        }
    };
    _self.clientListConfig.OnSearch = (searchValue) => {
      _self.clientSearchValue = searchValue;
      _self.loadClients();
    };
    _self.clientListConfig.OnRefresh = (event) => {
      _self.loadClients();
    };
    _self.clientListConfig.OnPageChanged = (pageNo, event) => {
      _self.loadClients();
    };
    if (_self.excSec.isFeatured('PRV')) {
      _self.auditorListConfig.OnAdd = () => {
        _self.manageAuditor(null);
      };
    }
  _self.auditorListConfig.OnRefresh = () => {
    _self.loadAuditors();
  };
  _self.auditorListConfig.OnPageChanged = (pageNo) => {
    _self.auditorListConfig.paging.pageNo = pageNo;
    _self.loadAuditors();
  };
  _self.auditorListConfig.OnSearch = (searchValue) => {
    _self.auditorSearchValue = searchValue;
    _self.loadAuditors();
  };
  _self.auditorListConfig.OnFilterClick = (event?) => _self.filterMenu.toggle(event);
  _self.auditorListConfig.OnFilter = () => {
  };
  }

  ngOnInit() {
    const _self = this;
    _self.stateChange(1);
    _self.setSortData();
    _self.loadImportClients();
  }
  loadAuditors() {
    const _self = this;
    _self.auditorListConfig.isLoading = true;
    let mi = _self.auditorListConfig.GetMetaInfo();
    mi =  _self.excFss.ApplyFilter(mi, _self.lstFilters, _self.lstSort);
    _self.excRest.sget(_self.excRest.computeUrl('ProviderConfig_AuditorR_List',
      {fts: _self.auditorSearchValue}), ExcCoreModule.Guid.NewGuid(),
      {MetaInfo: mi})
      .subscribe(response => {
        if (response.response.data !== undefined) {
          _self.auditorListData = response.response.data;
          _self.auditorListConfig.paging = response.response.paging;
        }
        _self.auditorListConfig.isLoading = false;
      });
  }
  loadClients() {
    const _self = this;
    _self.clientListConfig.isLoading = true;
    _self.excRest.sget(_self.excRest.computeUrl('Provider_ClientR_List',
      {fts: _self.clientSearchValue}), ExcCoreModule.Guid.NewGuid(),
      {})
      .subscribe(response => {
        if (response.response !== null) {
          if (response.response.data !== undefined) {
            _self.clientListData = response.response.data;
            _self.clientListConfig.paging = response.response.paging;
            _self.importClientList = [];
            for (const x of _self.clientListData) {
              if (x['HasImport'] === true) {
                _self.importClientList.push(x);
              }
            }
            _self.clients = _self.convertClientArray( _self.clientListData);
          }
          _self.clientListConfig.isLoading = false;
        }
      });
  }
  manageAuditor(data: any = null) {
    const _self = this;
    if (!_self.excSec.isFeatured('PRV')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    let auditor = {};
    if (data === null ) {
      auditor = null;
      ExcCoreModule.showModal(ProviderModalAuditorEditComponent, null, 'l',
        {Auditor: auditor, Data: auditor, IsFirstCall: _self.addAuditorFirstCall, AddMore: _self.addAuditorMore}, false, null).subscribe(ret => {
        if (ret.proceed === true) {
          _self.addAuditorFirstCall = false;
          _self.addAuditorMore = ret.AddMore;
          if (ret.auditor !== null) {
            const url = _self.excRest.computeUrl('ProviderConfig_AuditorC', {ID: ret.auditor.ID});
            _self.excRest.post(url, ret.auditor
              , {}).subscribe(obj => {
              if (obj) {
                if (_self.addAuditorMore === true) {
                 _self.manageAuditor();
                } else {
                  _self.loadAuditors();
                  _self.addAuditorFirstCall = true;
                  _self.addAuditorMore = false;
                }
              }
            });
          }
        } else {
          if (ret.IsFirstCall === false) {
            _self.loadAuditors();
          }
        }
      });
    } else {
      Object.assign(auditor, data);
      auditor['IsEdit'] = true;
      ExcCoreModule.showModal(ProviderModalAuditorEditComponent, null, 'l',
        {Auditor: auditor, Data: auditor}, false, null).subscribe(ret => {
        if (ret.proceed === true) {
          if (ret.auditor !== null) {
            const url = _self.excRest.computeUrl('ProviderConfig_AuditorU', {ID: ret.auditor.ID});
            _self.excRest.put(url, ret.auditor
              , {}).subscribe(obj => {
              if (obj) {
                _self.loadAuditors();
              }
            });
          }
        }
      });
    }
  }
  deleteAuditors (item) {
    const _self = this;
    const warningMessage = _self.getRessource('warningMessage');
    ExcCoreModule.showModal(warningMessage, _self.getGlobal('Delete'), 's', null, true, [ {
      text: this.getGlobal('No'),
      class: 'btn btn-submit',
      onClick: (overlay) => {
        overlay.close(false);
      }
    }, {
      text: this.getGlobal('Yes'),
      class: 'btn btn-submit',
      onClick: (overlay) => {
        overlay.close(true);
        _self.excRest.delete(_self.excRest.computeUrl('ProviderConfig_AuditorD' , { }),
          {
            ID: item.ID
          }, {}, false).subscribe(response => {
          _self.loadAuditors();
        });
      }
    }]).subscribe(x => {
    });
  }
  menuItemChange(data) {
    const _self = this;
    _self.state = data;
    switch (_self.state) {
      case 3: {
        _self.loadAuditors();
        break;
      }
      case 4: {
        _self.loadClients();
        break;
      }
      default: {
        break;
      }
    }
  }
  replaceEmptyString(text) {
    if (text !== null && text !== '' && text !== undefined) {
      return text;
    } else {
      return '-';
    }
  }
  stateChange(data) {
    const _self = this;
    _self.state = data;
    switch (_self.state) {
      case 3: {
        _self.loadAuditors();
        break;
      }
      case 4: {
       _self.loadClients();
        break;
      }
      default: {
        break;
      }
    }
  }
  setSortData() {
    const _self = this;
    _self.lstFilters = [
      new ExcFilter(2, '', 'Firstname', new ExcFilterCondition('LIKE', ''), 'fltSearchFirstName', 'ProviderConfigComponent.FirstName', false)
      , new ExcFilter(2, '', 'Lastname', new ExcFilterCondition('LIKE', ''), 'fltSearchLastName', 'ProviderConfigComponent.LastName', false)
      , new ExcFilter(2, '', 'City', new ExcFilterCondition('LIKE', ''), 'fltSearchAuditorCity', 'ProviderConfigComponent.AuditorCity', false)
    ];
    _self.lstSort = [
        new ExcSort('Lastname', 0, 'ProviderConfigComponent.LastName', 1)
      , new ExcSort('City', 0, 'ProviderConfigComponent.AuditorCity', 0)
      , new ExcSort('Country', 0, 'ProviderConfigComponent.AuditorCountry', 0)
      , new ExcSort('Zip', 0, 'ProviderConfigComponent.AuditorZip', 0)
    ];
    for (const x of _self.lstSort) {
      if (x !== undefined) {
        x.Container = _self.lstSort;
      }
    }
  }
  applyFilter() {
    const _self = this;
    _self.filterMenu.hide();
    _self.auditorListConfig.MetaInfo.dataFilter = {some: 'value'};
    _self.loadAuditors();
  }
  resetFilter() {
    const _self = this;
    _self.excFss.ResetFilter(_self.lstFilters, _self.lstSort);
    _self.filterMenu.hide();
    _self.auditorListConfig.MetaInfo.dataFilter = {};
    _self.loadAuditors();
  }
  showPopup() {
    const _self = this;
    if (_self.excSec.isFeatured('CLI_ADT_R') || _self.excSec.isFeatured('PRVbgf_ADT_R')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    ExcCoreModule.showModal(ProviderModalExportAuditComponent, null, 'm',
      {Client:  _self.clients/*, Data: auditor*/}, false, null).subscribe(ret => {
      if (ret.proceed === true) {
        if (ret.selected !== null) {
          _self.selected = ret.selected;
          _self.exportAuditList();
        }
      }
    });
  }
  showDealerPopup() {
    const _self = this;
    if (_self.excSec.isFeatured('PRV_DLR_R') || _self.excSec.isFeatured('PRVbfg_DLR_R')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    _self.selectedClient = null;
    ExcCoreModule.showModal(ProviderModalExportDealerComponent, null, 's',
      {Client:   _self.clients/*, Data: auditor*/}, false, null).subscribe(ret => {
      if (ret.proceed === true) {
          _self.selectedClient = ret.selectedClient;
          _self.exportDealerList();
      }
    });
  }
  exportAuditList() {
    const _self = this;
    _self.excRest.sget(_self.excRest.computeUrl('Provider_AuditR_Export',
      {
         audityear : _self.selected.AuditYear,
         auditmonth: _self.selected.AuditMonth,
         auditstatus: _self.selected.AuditStatus,
         client: _self.selected.mandant,
         cult: _self.translateService.currentLang
      }), ExcCoreModule.Guid.NewGuid(),
      {}) .subscribe(response => {
    });
  }
  exportDealerList() {
    const _self = this;
    _self.excRest.sget(_self.excRest.computeUrl('Provider_DealerR_Export',
      {client: _self.selectedClient, cult:  _self.translateService.currentLang}), ExcCoreModule.Guid.NewGuid(),
      {})
      .subscribe(response => {
      });
  }
  convertClientArray (clients: any[]) {
    const _self = this;
    const Clietnts: any[] = [];
    Clietnts.push({value: 0, text: _self.getGlobal('SelectAll') });
    clients.forEach(item => {
      Clietnts.push({value: Number(item.Mdt_Id), text: item.Mdt_Kbz});
    });
    return Clietnts;
  }
  private getJsonLocalized(key: string, defaultValue?: any) {
    if (this.json[this.currentLang()] !== undefined && this.json[this.currentLang()] !== null) {
      if (this.json[this.currentLang()][key] !== undefined && this.json[this.currentLang()][key] !== null) {
        return this.json[this.currentLang()][key];
      }
    }
    return defaultValue || null;
  }
  cancelPopup(e) {
    const _self = this;
    _self.popup.hide(e);
  }

  applyPopup(e) {
    const _self = this;
    _self.popup.hide(e);
  }
  showImportPopup(e) {
    const _self = this;
    _self.selectedClient = null;
    ExcCoreModule.showModal(ProviderModalImportByClientComponent, null, 's',
      {Client:   _self.clients/*, Data: auditor*/}, false, null).subscribe(ret => {
      if (ret.proceed === true) {
        _self.selectedClient = ret.selectedClient;
      }
    });
  }
  loadImportClients() {
    const _self = this;
    _self.importClientListConfig.isLoading = true;
    _self.excRest.sget(_self.excRest.computeUrl('Provider_ClientR_List',
      {}), ExcCoreModule.Guid.NewGuid(),
      {})
      .subscribe(response => {
        if (response.response !== null) {
          if (response.response.data !== undefined) {
            _self.clientListData = response.response.data;
            _self.importClientListConfig.paging = response.response.paging;
            _self.importClientList = [];
            for (const x of _self.clientListData) {
              if (x['HasImport'] === true) {
                _self.importClientList.push(x);
              }
            }
            _self.clients = _self.convertClientArray( _self.clientListData);
          }
          _self.importClientListConfig.isLoading = false;
        }
      });
  }
}
